import Cookie from 'real-js-cookie'

/**
 * Workaround for wtf tier issue: because handling different module types sucks with the
 * different build tools and poorly made libraries.
 * Issue is that some lib have `import * as Cookie from 'js-cookie'
 * then use it as `Cookie.get`
 * Problem is that Cookie.get is actually on the Prototype so the import ends up being just
 * ` {default: theLib }` and thus get is not found.
 *
 * So the wrapper here allow the usual export but also export a get function which can be imported even
 * with the `* as` syntax.
 *
 * Note that the problematic use of the syntax `import *` is not limited to our project and while it could be corrected in other project
 * we depend on, this might introduce braeking changes on other project too so it's easier to fix it here
 *
 */

export default Cookie

export const get = (...args) => Cookie.get(...args)
